export const API_ROOT = 'https://rest.dev.boxcast.com';
export const INTEGRATIONS_ROOT = 'https://integration.dev.boxcast.com';
export const LOGIN_URL = 'https://login.dev.boxcast.com';
export const AUTH_URL =
  'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=fabmaqloe4wokqzincep&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=dashboard';
export const SWITCHER_AUTH_URL =
  'https://rest.dev.boxcast.com/oauth2/auth?response_type=code&client_id=glolh40ngfpuvh84jzc4&redirect_uri=https%3A%2F%2Fdashboard.dev.boxcast.com%2F&scope=owner';
export const TOKEN_URL = 'https://rest.dev.boxcast.com/oauth2/token';
export const LOGOUT_URL = 'https://rest.dev.boxcast.com/oauth2/auth/sessions/login/revoke';
export const GEO_URL = 'https://geo.dev.boxcast.com/json/';

// boxcast_js v3
export const BOXCAST_JS = `//js.dev.boxcast.com/v3.min.js`;
export const BOXCAST_JS_ENV = 'dev';
export const BOXCAST_JS_EMBED_URL = '//js.dev.boxcast.com/v3.min.js';
export const BOXCAST_JS_IFRAME_URL = 'https://dev.boxcast.tv/view-embed';
export const BOXCAST_JS_APP_EMBED_URL = 'https://dev.boxcast.tv/embed-app.html';
export const SYNDICATION_SERVICE_BASE_URL = 'https://syndication.dev.boxcast.com';

export const BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.dev.boxcast.com';
export const WIDGET_JS = '//js.dev.boxcast.com/v2.widget.js';
export const BOXCAST_SHOW_URL = 'https://dev.boxcast.tv/channel/';
export const BOXCAST_TV_SHOW_URL = 'https://dev.boxcast.tv/channel/';
export const BOXCAST_TV_HIGHLIGHT_URL = 'https://dev.boxcast.tv/highlights/';
export const BOXCAST_TV_VIDEO_PORTAL_URL = 'https://dev.boxcast.tv/video-portal/';
export const IMG_ROOT = 'https://dashboard.dev.boxcast.com/img/';
export const FACEBOOK_APP_ID = '252291028958723';
export const PLAID_ENV = 'sandbox';
export const PLAID_KEY = 'd9d6e3622f442cf5a33073a50e3425';
export const STRIPE_KEY = 'pk_test_jJXNd6tHTMtwyQWWHE4lGQvJ';
export const YOUTUBE_CLIENT_ID =
  '272935062177-t44tv0ss9scbhseoajt0ie36ucgt5gcv.apps.googleusercontent.com';
export const YOUTUBE_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com?oauth_reply_from=youtube';
export const VIMEO_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com?oauth_reply_from=vimeo';
export const TWITTER_OAUTH_REDIRECT = 'https://dashboard.dev.boxcast.com/#/settings/twitter';

export const DATADOG_LOGS_CLIENT_TOKEN = 'pubd6bf579ae45e618194ddc4138bd04efb';
export const INTERCOM_APP_ID = 'qjlz07dd';

export const VUE_DASHBOARD_ROOT = 'https://dashboard.dev.boxcast.com';
export const NG_DASHBOARD_ROOT = 'https://dashboard.dev.boxcast.com';



// WEBPACK FOOTER //
// ./app/environments/dev.js